import { apiClient } from "../client";
const ENDPOINTS = {
    BASE: "/additional-works",
    BY_JOB: "/additional-works/job",
};
export const additionalWorksService = {
    // Get additional works for a job
    getAdditionalWorksByJob: (jobId) => apiClient.get(`${ENDPOINTS.BY_JOB}/${jobId}`),
    // Get summary for a job
    getSummary: (jobId) => apiClient.get(`${ENDPOINTS.BY_JOB}/${jobId}/summary`),
    // Get a single additional work
    getAdditionalWork: (id) => apiClient.get(`${ENDPOINTS.BASE}/${id}`),
    // Create additional work
    createAdditionalWork: (data) => apiClient.post(ENDPOINTS.BASE, data),
    // Update additional work
    updateAdditionalWork: (id, data) => apiClient.put(`${ENDPOINTS.BASE}/${id}`, data),
    // Update additional work status (open/close)
    updateAdditionalWorkStatus: (id, data) => apiClient.put(`${ENDPOINTS.BASE}/${id}/status`, data),
    // Approve or decline
    approveOrDecline: (id, data) => apiClient.post(`${ENDPOINTS.BASE}/${id}/process`, data),
    // Complete
    complete: (id, data) => apiClient.post(`${ENDPOINTS.BASE}/${id}/complete`, data),
    // Delete additional work
    deleteAdditionalWork: (id) => apiClient.delete(`${ENDPOINTS.BASE}/${id}`),
};
